"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagButton = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const TagButton = (props) => {
    const { mainColor = true, className, onClick, children } = props;
    const classNames = [mainColor ? 'main-color-set' : 'second-color-set', className].join(' ');
    return (react_1.default.createElement("div", { className: "tag-button-component", "data-testid": "tag-button-component" },
        react_1.default.createElement("button", { className: classNames, onClick: onClick }, children)));
};
exports.TagButton = TagButton;
